exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".IA_sharePointManagementEditPanel_2L3equANBvvz7NGgwawOO8 {\n  position: relative;\n  width: 100%;\n  float: left;\n}\n\n.IA_sharePointManagementSearchResult_3-NSjZeCsMJZtk6d4Ys1L7 {\n  padding: 10px 0;\n  clear: both;\n}", ""]);

// Exports
exports.locals = {
	"IA_sharePointManagementEditPanel": "IA_sharePointManagementEditPanel_2L3equANBvvz7NGgwawOO8",
	"IA_sharePointManagementSearchResult": "IA_sharePointManagementSearchResult_3-NSjZeCsMJZtk6d4Ys1L7"
};